import React, { FC } from 'react';
import { LoginView } from '../components';

export const LoginPage: FC = () => {
  return <LoginView />;
};
